function stringShrink(X) {
    let stage1 = X.substring(0, 20);
    let stage2 = stage1.split("").reverse().join("");
    let stage3 = stage2.substring(stage2.indexOf(' '), stage2.length);
    let stage4 = stage3.split("").reverse().join("")
    return stage4;
}

function heightMatch() {
    let totalHeight = '0px';
    let textHeight = '0px';
    for (i = 0; i < document.getElementsByClassName('recoCard').length; i++) {
        if (getComputedStyle(document.getElementsByClassName('recoCard')[i]).getPropertyValue('height') > totalHeight) {
            totalHeight = getComputedStyle(document.getElementsByClassName('recoCard')[i]).getPropertyValue('height');
        }
        if (document.getElementsByClassName('recoBlurb').length > 0) {
            if (getComputedStyle(document.getElementsByClassName('recoBlurb')[i]).getPropertyValue('height') > textHeight) {
                textHeight = getComputedStyle(document.getElementsByClassName('recoBlurb')[i]).getPropertyValue('height');
            }
        }
    }
    document.getElementById('recoGrid').style.height = totalHeight;
    let blurb = document.getElementsByClassName('recoBlurb');
    for (i = 0; i < blurb.length; i++) {
        blurb[i].style.height = textHeight;
    }
}

function recoClose() {
    document.getElementById('recoGrid').style.opacity = 0;
    setTimeout(function () {
        document.getElementById('recoGrid').style.height = 0;
        document.getElementById('recoCollection').style.padding = `20px`;
    }, 250)
    setTimeout(function () {
        document.getElementById('recommendations').innerHTML = '';
    }, 600)
}

function readMore(X) {
    if (document.getElementById(`readMore${X}`).dataset.state == 'closed') {
        document.getElementById(`dots${X}`).style.display = 'none';
        document.getElementById(`recMore${X}`).style.display = 'inline';
        document.getElementById(`readMore${X}`).innerHTML = '<span>Read Less</span>';
        document.getElementById(`readMore${X}`).dataset.state = 'open';
    } else {
        document.getElementById(`dots${X}`).style.display = 'inline';
        document.getElementById(`recMore${X}`).style.display = 'none';
        document.getElementById(`readMore${X}`).innerHTML = '<span>Read More</span>';
        document.getElementById(`readMore${X}`).dataset.state = 'closed';
    }
    heightMatch()
}

let boxWidth = document.documentElement.clientWidth;
let boxHeight = (((((document.documentElement.clientWidth - 40) * 0.2) - (16 * (2 / 3)) - 26) / 2) + 26) + 30;

async function getProducts(X) {
    let bestSellers
    if (localStorage.getItem('currentID') && localStorage.getItem('currentidx') && localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`) && localStorage.getItem('productType') == 'tyre') {
        if (X == 'rear') {
            bestSellers = JSON.parse(localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`)).fitments[localStorage.getItem('currentidx')].r_tyres.best_sellers;
        } else {
            bestSellers = JSON.parse(localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`)).fitments[localStorage.getItem('currentidx')].f_tyres.best_sellers;
        }
    } else {
        if(document.getElementById('recommendations').innerHTML.length > 0) {
            recoClose()
        }
        return;
    }
    if (!bestSellers || bestSellers.length == 0) {
        if(document.getElementById('recommendations').innerHTML.length > 0) {
            recoClose()
        }
        return;
    }
    let queryString = '';
    for (i = 0; i < bestSellers.length && i < 3; i++) {
        queryString = `${queryString}
        Product${i}: product(id:"gid://shopify/Product/${bestSellers[i].product_gid}") {
		title
		handle
		id
		images(first:2) {
			edges {
				node {
					altText
					url
				}
			}
		}
		variants(first:250) {
			edges {
				node {
					id
					metafield(key:"promotion_secondary_text",namespace:"display") {
						namespace
						key
						value
					}
					availableForSale
					price {
						amount
					}
				}
			}
		}
	}`
    }
    let req = `{
	    ${queryString}
    }`
    let innerReqString = JSON.stringify({ query: req });
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
            let resp = JSON.parse(this.responseText);
            let prods = [];
            if (resp.data.Product0) {
                prods.push(resp.data.Product0);
            }
            if (resp.data.Product1) {
                prods.push(resp.data.Product1);
            }
            if (resp.data.Product2) {
                prods.push(resp.data.Product2);
            }
            if(prods.length == 0) {
                recoClose();
                return;
            }
            for (i = 0; i < prods.length && i < 3; i++) {
                prods[i].variants.edges = prods[i].variants.edges.filter(edge => edge.node.id == `gid://shopify/ProductVariant/${bestSellers[i].variant_gid}`);
                if (bestSellers[i].variant_reason) {
                    prods[i].variant_reason = X.products[i].variant_reason;
                }
            }
            let inner = prodCards(prods);
            if (JSON.parse(localStorage.getItem(`fitmentInfo${localStorage.getItem('currentID')}`)).vehicle_use_case) {
                let vehicleBlurb = `<span class="recoCase">${X.vehicle_use_case.substring(0, 180)}<span class="dots" id="dotsV">...</span><span class="recoMore" id="recMoreV">${X.vehicle_use_case.substring(180, X.vehicle_use_case.length)}</span></span><div class="recoMoreButton" id="readMoreV" onclick="readMore('V')" data-state="closed"><span>Read More</span></div>`;
                if (document.getElementById('vBlurbTarget')) {
                    document.getElementById('vBlurbTarget').innerHTML = vehicleBlurb;
                }
            }
            document.getElementById('recommendations').innerHTML = inner;
            heightMatch()
            document.getElementById('recoCollection').style.padding = `20px`;
            setTimeout(function () {
                document.getElementById('recoGrid').style.opacity = 100;
            }, 350)
        }
    });

    xhr.open("POST", `https://${storeString}.myshopify.com/api/2025-04/graphql.json`);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", sFront);

    xhr.send(innerReqString);
}

function prodCards(X) {
    let avail = '';
    let prod = '';
    let params = new URLSearchParams(window.location.search)
    let paramArray = Array.from(params);
    let paramString = '';
    for (j = 0; j < paramArray.length; j++) {
        if (paramArray[j][0].includes('filter.v.m')) {
            if (j == 0) {
                paramString = `${paramArray[j][0]}=${paramArray[j][1]}`;
            } else {
                paramString = `${paramString}&${paramArray[j][0]}=${paramArray[j][1]}`;
            }
        }
    }
    if (paramString.length > 0) {
        paramString = `??filter_params${paramString}endparam`;
    }
    for (i = 0; i < X.length; i++) {
        let promo = '';
        let ribbon = '';
        let indiv = '';
        if (X[i].variants.edges[0].node.metafield) {
            let save
            if (X[i].variants.edges[0].node.metafield.value.includes('Buy 3')) {
                save = Math.floor(X[i].variants.edges[0].node.price.amount - 25);
                indiv = (((X[i].variants.edges[0].node.price.amount * 3) + 25) / 4)
                indiv = `${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(indiv)} each in a set of 4`
            } else if (X[i].variants.edges[0].node.metafield.value.includes('%')) {
                let percentage
                if (X[i].variants.edges[0].node.metafield.value.split('%')[0].includes(' ')) {
                    percentage = (X[i].variants.edges[0].node.metafield.value.split('%')[0].split(' ')[X[i].variants.edges[0].node.metafield.value.split('%')[0].split(' ').length - 1])
                } else {
                    percentage = (X[i].variants.edges[0].node.metafield.value.split('%')[0])
                }
                save = Math.floor((X[i].variants.edges[0].node.price.amount * 4) * (percentage / 100))
                indiv = `${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(((X[i].variants.edges[0].node.price.amount) * (percentage / 100)))} each in a set of 4`;
            } else if (X[i].variants.edges[0].node.metafield.value.toLowerCase().includes('cash')) {
                save = X[i].variants.edges[0].node.metafield.value.split(' ')[0].replace('$', '');
                indiv = `${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((X[i].variants.edges[0].node.price.amount - (save / 4)))} each in a set of 4`;
            }
            if (save) {
                promo = `<div class="primary_promotion  tyre recoPrimaryPromotion"><span id="variant-metafield-primary_text" class="recoPromoHighlight2"><h3>SAVE $${save}</h3><p>ON A SET OF 4</p></span></div>`;
                ribbon = `<div class="ribbon recoRibbon"><span id="variant-metafield-secondary_text">${X[i].variants.edges[0].node.metafield.value}</span></div>`;
            } else {
                ribbon = `<div class="ribbon recoRibbon"><span id="variant-metafield-secondary_text">${X[i].variants.edges[0].node.metafield.value}</span></div>`;
            }
        }
        if (X[i].variants.edges[0].node.availableForSale) {
            avail = `<div class="variantStock plpStock" id="stockIcon"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280.000000 1253.000000" preserveAspectRatio="xMidYMid meet" class="availIcon"><g transform="translate(0.000000,1253.000000) scale(0.100000,-0.100000)" fill="#00ac00;" stroke="none"><path d="M12000 12520 c-192 -27 -395 -98 -655 -230 -446 -225 -961 -590 -1620 -1149 -926 -785 -2158 -2000 -3466 -3416 -661 -717 -1389 -1537 -1913 -2157 -87 -104 -159 -188 -160 -188 -1 0 -67 34 -146 76 -255 134 -875 442 -1078 536 -849 391 -1441 595 -1912 659 -134 18 -368 13 -479 -10 -224 -48 -405 -181 -495 -366 -52 -104 -69 -183 -70 -310 -1 -105 1 -113 32 -177 29 -59 55 -87 235 -254 438 -407 919 -904 1273 -1315 792 -921 1625 -2167 2579 -3858 168 -297 234 -355 405 -355 66 0 96 5 132 21 113 51 158 111 238 313 135 341 398 964 565 1335 1285 2866 2820 5295 4654 7365 520 587 971 1049 1821 1866 665 640 790 788 844 1005 81 328 -187 601 -604 614 -63 2 -144 0 -180 -5z"></path></g></svg><span class="availabilityText textGreen">Available</span></div>`;
        }
        let recoBlurb = '';
        if (X[i].variant_reason) {
            recoBlurb = X[i].variant_reason;
            recoBlurb = `<span class="recoBlurb">${recoBlurb.substring(0, 135)}<span class="dots" id="dots${i}">...</span><span class="recoMore" id="recMore${i}">${recoBlurb.substring(135, recoBlurb.length)}</span></span><div class="recoMoreButton" id="readMore${i}" onclick="readMore(${i})" data-state="closed"><span>Read More</span></div>`;
        }
        let images = '';
        for (q = 0; q < X[i].images.edges.length; q++) {
            images = `${images}<img src="${X[i].images.edges[q].node.url}&width=950" alt="${X[i].title}" srcset="${X[i].images.edges[q].node.url}&width=185 185w, ${X[i].images.edges[q].node.url}&width=200 200w, ${X[i].images.edges[q].node.url}&width=370 370w, ${X[i].images.edges[q].node.url}&width=420 420w, ${X[i].images.edges[q].node.url}&width=650 650w, ${X[i].images.edges[q].node.url}&width=750 750w, ${X[i].images.edges[q].node.url}&width=950 950w" width="950" height="950" class="card-media-image" sizes="(min-width: 1200px) 420px, (min-width: 750px) calc((100vw - 4rem - 3rem) / 3), calc((100vw - 3rem - 1rem) / 2)"></img>`;
        }
        prod = `${prod}<li class="grid-item recoGridItem" id="recoTile${i}"><reco-card class="card card-product card-product-no-rating color-background-2 recoCard"><div class="recoHoriz"><figure class="card-media recoCardMedia"><a href="https://${window.location.host}/products/${X[i].handle}?variant=${X[i].variants.edges[0].node.id.replaceAll('gid://shopify/ProductVariant/', '')}${paramString}" class="js-product-link"><div class="aspect-ratio" style="--ratio-percent: 100.0%;">${images}</div></a>${promo}</figure><div class="card-info-wrap recoCardInfo"><div class="card-info"><h3 class="card-heading typography-body"><a title="${X[i].title}" href="https://${window.location.host}/products/${X[i].handle}?variant=${X[i].variants.edges[0].node.id.replaceAll('gid://shopify/ProductVariant/', '')}${paramString}" class="js-product-link new">${X[i].title}</a></h3></div><div class="card-footer"><div class="price recoPrice"><div class="price-container"><div class="price-regular"><span class="price-item price-item-regular VP-50100 FP-50100 -">${new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(X[i].variants.edges[0].node.price.amount)}</span></div>${ribbon}<div class="promoTab">${indiv}</div></div></div></div>${avail}</div></div>${recoBlurb}</reco-card></li>`;
    }
    prod = `<div id="recoCollection" class="collection"><fieldset id="fieldBorder"><legend class="page-hero-heading" id="customerChoice">Our customer's choice for your ${stringShrink(localStorage.getItem('currentModel'))}</legend><ul id="recoGrid" class="grid product-grid grid-2-col grid-3-col-tablet" data-id="template--19910393364730__product-grid">${prod}</ul></fieldset></div>`;
    return prod;
}

window.addEventListener('resize', function () {
    if (document.getElementById('recoGrid')) {
        heightMatch()
        if (document.documentElement.clientWidth < 501 && document.documentElement.clientWidth > 450) {
            document.getElementById('recoCollection').style.padding = `20px 10px`;
        } else if (document.documentElement.clientWidth < 451) {
            document.getElementById('recoCollection').style.padding = `20px 0`;
        } else {
            document.getElementById('recoCollection').style.padding = `20px`;
        }
    }
});